import React from 'react';
import FaNumericInput from "../FactureeComponents/FaNumericInput";
import {Box, Divider, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper} from "@mui/material";
import ShowCode from "../helpers/ShowCode.js";

const FactureeCompNumericInputExmpl = () => {

  const example1 = `<>
  <FaNumericInput
    value={1005.50}
    label={"Enter a number"}
    error={"Custom Error String"}
    regex={""}
    onValueChange={(val) => console.log(val)}
  />
</>`;

  const example2 = `<>
  <FaNumericInput
    value={5.5}
    variant={"outlined"}
    label={"Enter a number"}
    error={"Custom Error String"}
    regex={""}
    onValueChange={(val) => console.log(val)}
  />
</>`;

  return (
    <Box sx={{padding: '8rem 8vw 2rem 8vw'}}>
      <Typography variant={"h3"} sx={{marginBottom: '2rem'}}>FaNumericInput Component</Typography>

      <Typography>The FaNumericInput auto-formats numeric representation by language convention, iE. 1.000,00 for „de" but 1,000.00 for „en". </Typography>

      <Divider/>

      <Typography variant={"h4"} sx={{marginBottom: '1.5rem', marginTop: '2.5rem'}}>Numeric Input standard</Typography>
      <FaNumericInput
          value={1005.50}
          label={"Enter a number"}
          error={"Custom Error String"}
          regex={""}
          onValueChange={(val) => console.log(val)}
      />
      <ShowCode codeString={example1} scope={{ React, FaNumericInput }} />
      <br/>
      <Divider/>

      <Typography variant={"h4"} sx={{marginBottom: '1.5rem', marginTop: '2.5rem'}}>Numeric Input outlined</Typography>
      <FaNumericInput
          value={5.5}
          variant={"outlined"}
          label={"Enter a number"}
          error={"Custom Error String"}
          regex={""}
          onValueChange={(val) => console.log(val)}
      />
      <ShowCode codeString={example2} scope={{ React, FaNumericInput }} />

      <Typography variant={"h4"} sx={{marginBottom: '0.5rem', marginTop: '3rem'}}>API Reference</Typography>
      <Typography variant={"body2"} color="text.secondary" sx={{marginBottom: '2rem'}}>
        Complete list of all props supported by the FaNumericInput component.
      </Typography>

      <TableContainer component={Paper} sx={{marginBottom: '2rem', '& code': {fontSize: '0.875rem'}}}>
        <Table>
          <TableHead>
            <TableRow sx={{backgroundColor: 'primary.main'}}>
              <TableCell sx={{color: 'white', fontWeight: 'bold', width: '20%'}}>Prop</TableCell>
              <TableCell sx={{color: 'white', fontWeight: 'bold', width: '25%'}}>Type</TableCell>
              <TableCell sx={{color: 'white', fontWeight: 'bold', width: '15%'}}>Default</TableCell>
              <TableCell sx={{color: 'white', fontWeight: 'bold', width: '40%'}}>Description</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell><code>value</code> *</TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>number</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>-</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}>The numeric value displayed in the input field.</TableCell>
            </TableRow>
            <TableRow>
              <TableCell><code>error</code> *</TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>string</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>-</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}>Error message to display when validation fails.</TableCell>
            </TableRow>
            <TableRow>
              <TableCell><code>regex</code> *</TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>string</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>-</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}>Regular expression pattern for input validation.</TableCell>
            </TableRow>
            <TableRow>
              <TableCell><code>onValueChange</code> *</TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>(value: number) =&gt; void</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>-</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}>Callback function triggered when the input value changes.</TableCell>
            </TableRow>
            <TableRow>
              <TableCell><code>id</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>string</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>-</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}>Optional ID attribute for the input element.</TableCell>
            </TableRow>
            <TableRow>
              <TableCell><code>variant</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>'standard' | 'outlined'</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>"standard"</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}>Visual variant of the input field.</TableCell>
            </TableRow>
            <TableRow>
              <TableCell><code>placeholder</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>string</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>-</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}>Placeholder text displayed when the input is empty.</TableCell>
            </TableRow>
            <TableRow>
              <TableCell><code>label</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>string</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>-</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}>Label text displayed above the input field.</TableCell>
            </TableRow>
            <TableRow>
              <TableCell><code>size</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>'small' | 'medium'</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>"medium"</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}>Size of the input field.</TableCell>
            </TableRow>
            <TableRow>
              <TableCell><code>disabled</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>boolean</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>false</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}>When true, disables the input field preventing user interaction.</TableCell>
            </TableRow>
            <TableRow>
              <TableCell><code>prefix</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>string</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>-</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}>Prefix string to display before the numeric value.</TableCell>
            </TableRow>
            <TableRow>
              <TableCell><code>sx</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>any</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>-</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}>Material-UI sx prop for custom styling.</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>

      <Typography variant={"body2"} color="text.secondary" sx={{fontStyle: 'italic'}}>
        * Required prop
      </Typography>
    </Box>
  );
};

export default FactureeCompNumericInputExmpl;
